import React, { useContext, useState } from 'react';
import { IFindCallerObject } from '@vfit/shared/models';
import { LoggerInstance } from '@vfit/shared/data-access';
import { IProduct, updateProduct } from '@vfit/consumer/data-access';
import { ID_FLOWS, DEFAULT_CURRENT_STEP_KEY } from './CheckoutEnergy/checkoutEnergy.constants';
import { IEnergyContext, IEnergyProvider } from './energy.models';
import {
  DEFAULT_FIND_CALLER,
  DEFAULT_LAST_CARD,
  DEFAULT_SLIDES_GO_BACK,
  DEFAULT_PRODUCT,
} from './energy.context.data';

export const EnergyContext = React.createContext<IEnergyContext>({
  findCaller: DEFAULT_FIND_CALLER,
  isLastCard: DEFAULT_LAST_CARD,
  slidesGoBack: DEFAULT_SLIDES_GO_BACK,
  currentStepKey: ID_FLOWS.PERSONAL_INFO,
  hideStickyBar: false,
  isModalButtonSticky: false,
  isDisabledBackButton: false,
  product: DEFAULT_PRODUCT as IProduct,
  printContext: () => {
    return;
  },
  setFindCaller: () => {
    return;
  },
  setIsLastCard: () => {
    return;
  },
  setSlidesGoBack: () => {
    return;
  },
  setCurrentStepKey: () => {
    return;
  },
  setIsDisabledBackButton: () => {
    return;
  },
  setHideStickyBar: () => {
    return;
  },
  setIsModalButtonSticky: () => {
    return;
  },
  setProduct: () => {
    return;
  },
});

export const EnergyProvider = ({ children }: IEnergyProvider) => {
  const [findCaller, setCaller] = useState<IFindCallerObject>({
    ...DEFAULT_FIND_CALLER,
  });

  const [isLastCard, setLastCard] = useState<boolean>(DEFAULT_LAST_CARD);

  const [slidesGoBack, setSlidesGoBackData] = useState<number>(DEFAULT_SLIDES_GO_BACK);

  const [currentStepKey, setCurrentStepKeyData] = useState<string>(DEFAULT_CURRENT_STEP_KEY);

  const [hideStickyBar, setHideStickyBarData] = useState<boolean>(false);

  const [isModalButtonSticky, setIsModalButtonStickyStatus] = useState<boolean>(false);

  const [isDisabledBackButton, setisDisabledBackButtonStatus] = useState<boolean>(false);

  const [product, setProductData] = useState<IProduct>(DEFAULT_PRODUCT as IProduct);

  const setFindCaller = (findCallerData: IFindCallerObject) => {
    setCaller({ ...findCallerData });
  };

  const setIsLastCard = (isLastCardLocal: boolean) => {
    setLastCard(isLastCardLocal);
  };

  const setSlidesGoBack = (slidesBack: number) => {
    setSlidesGoBackData(slidesBack);
  };

  const setCurrentStepKey = (currentStepKeyLocal: string) => {
    setCurrentStepKeyData(currentStepKeyLocal);
  };

  const setHideStickyBar = (hSB: boolean) => {
    setHideStickyBarData(hSB);
  };

  const setIsModalButtonSticky = (isModalButtonStickyProps: boolean) => {
    setIsModalButtonStickyStatus(isModalButtonStickyProps);
  };

  const setIsDisabledBackButton = (isDisabledBackButtonProps: boolean) => {
    setisDisabledBackButtonStatus(isDisabledBackButtonProps);
  };

  const setProduct = (prodData: IProduct) => {
    updateProduct(prodData);
    setProductData(prodData);
  };

  const printContext = () => {
    LoggerInstance.info('context', {
      findCaller: {
        ...findCaller,
      },
      isLastCard: isLastCard || false,
      slidesGoBack,
      currentStepKey,
      hideStickyBar,
      isModalButtonSticky,
      isDisabledBackButton,
      product,
    });
  };

  return (
    <EnergyContext.Provider
      //* eslint-disable-next-line react/jsx-no-constructed-context-values */
      value={{
        findCaller,
        setFindCaller,
        isLastCard,
        setIsLastCard,
        slidesGoBack,
        setSlidesGoBack,
        currentStepKey,
        setCurrentStepKey,
        printContext,
        hideStickyBar,
        setHideStickyBar,
        isModalButtonSticky,
        setIsModalButtonSticky,
        product,
        setProduct,
        isDisabledBackButton,
        setIsDisabledBackButton,
      }}
    >
      {children}
    </EnergyContext.Provider>
  );
};

export const useEnergyCheckout = () => useContext(EnergyContext);
